module.exports = __webpack_public_path__ + "static/media/castanho.72394027.png";